import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-cloud-done",
  "use": "gw-cloud-done-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"gw-cloud-done\"><path fill=\"none\" d=\"M0 0h24v24H0Z\" /><path d=\"M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96Zm-8.66 5.675a.963.963 0 0 1-1.368 0l-2.038-2.04a.975.975 0 0 1 0-1.375.963.963 0 0 1 1.368 0l1.349 1.356 4.347-4.37a.963.963 0 0 1 1.368 0 .975.975 0 0 1 0 1.375l-5.026 5.054Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol